var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.5823V34.5823M20 19.5823L15.8334 22.9157M20 19.5823L24.1667 22.9157M8.39002 14.7773C6.8137 15.174 5.43648 16.1326 4.51711 17.4731C3.59773 18.8135 3.19949 20.4436 3.3972 22.057C3.5949 23.6704 4.37495 25.156 5.59079 26.2349C6.80663 27.3137 8.37457 27.9114 10 27.9157H11.6667",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3834 11.4789C25.8138 9.22317 24.4077 7.26845 22.4503 6.01097C20.4929 4.7535 18.1306 4.28736 15.8422 4.70705C13.5538 5.12674 11.5107 6.40085 10.1269 8.27111C8.74308 10.1414 8.1222 12.4678 8.3901 14.7789C8.3901 14.7789 8.6451 16.2489 9.16677 17.0822",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 27.9167C29.5104 27.9159 30.6736 27.6659 31.7468 27.1831C32.8199 26.7003 33.7786 25.9958 34.5599 25.1158C35.3411 24.2358 35.9271 23.2003 36.2793 22.0775C36.6315 20.9548 36.7419 19.7701 36.6033 18.6016C36.4647 17.433 36.0801 16.3071 35.475 15.2979C34.8698 14.2887 34.0578 13.4191 33.0924 12.7463C32.1269 12.0735 31.03 11.6129 29.8737 11.3946C28.7173 11.1763 27.5279 11.2054 26.3837 11.48L24.167 12.0833",
    stroke: "#191D23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.605371387d95f0d47b8e5b10c86d80fa.svg";
export { ForwardRef as ReactComponent };